<template>
  <div class="privacyPage">
    <dl>
      <dt style="font-size: 18px"></dt>
      <div class="privacyCon">
        <!--
				구 데이터는 class="privacy_old" 추가
				뒤에 클래스명은 파일명이랑 같게 매칭
				-->

        <terms id="terms">
          <AgreeTremsText></AgreeTremsText>
          <!-- <script>loadHTML("/agree/termsText.html");</script> -->
        </terms>
      </div>
    </dl>
  </div>
</template>
<script>
import { onMounted, onBeforeUnmount } from 'vue'
import AgreeTremsText from '../components/AgreeTremsText.vue'
// import { onMounted, onUnmounted } from 'vue';

export default {
  name: 'AgreeTrem',
  components: {
    AgreeTremsText,
  },
  setup() {
    const hideHeader = () => {
      const header = document.getElementById('header')
      if (header) {
        header.style.display = 'none'
      }
    }

    const showHeader = () => {
      const header = document.getElementById('header')
      if (header) {
        header.style.display = ''
      }
    }

    onMounted(() => {
      hideHeader()
      window.addEventListener('beforeunload', showHeader)
    })

    onBeforeUnmount(() => {
      showHeader()
      window.removeEventListener('beforeunload', showHeader)
    })
  },
  // setup() {
  //   localStorage.setItem('chkPoint', "trigger");

  //   // 창 닫기 이벤트 핸들러
  //   const handleBeforeUnload = () => {
  //     localStorage.removeItem('chkPoint');
  //   };

  //   // 컴포넌트가 마운트될 때 localStorage에 `chkPoint` 설정
  //   onMounted(() => {
  //     localStorage.setItem('chkPoint', "trigger");
  //     // 창 닫기 이벤트 핸들러 등록
  //     window.addEventListener('beforeunload', handleBeforeUnload);
  //   });

  //   // 컴포넌트가 언마운트될 때 이벤트 핸들러 제거
  //   onUnmounted(() => {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //   });
  // }
}
</script>
<style>
/* mvaccine 추가 CSS */
body {
  font-weight: 400;
  color: #222;
  line-height: 1;
  font-family: 'SCDream', 'Noto Sans KR', sans-serif;
  word-break: keep-all;
}

html body * {
  line-height: 2;
}

p {
  font-size: 14px;
  line-height: 2;
}

p.top {
  line-height: 2;
  font-size: 14px;
  margin-bottom: 30px;
}

.tit {
  line-height: 2;
  font-size: 18px;
  font-weight: bold;
}

.mt10 {
  margin-top: 10px;
}

.dep-3 > li:before {
  content: '• ';
}

.dep-1 > li {
  font-size: 12px;
  margin-bottom: 30px;
}

.table {
  font-size: 12px;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
  background: #fff;
}

.table thead th {
  font-weight: bold;
  background: #f9f9f9;
}

.table th {
  text-align: center;
}

.table td,
.table th {
  border: 1px solid #bdbdbd;
  line-height: 16px;
  padding: 5px;
}

.date li {
  text-align: right;
  font-size: 12px;
}

.w {
  text-align: left;
}

.tab-1 {
  width: 100%;
  border: 1px solid #000;
}

.tab-1 > thead td {
  background-color: #dddddd;
}

.tab-1 td {
  border: 1px solid #000;
  text-align: center;
}
</style>
